import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Line,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer,
  XAxis,
  ComposedChart,
  Area,
  ReferenceDot,
} from 'recharts';
import { ChartLegend } from '../../../../../../../../components/chart-legend/chart-legend';
import { Header } from '../../../../../../../../components/header';
import { Triangle } from '../triangle/triangle';

type LesserChartProps = {
  value: number;
  hysteresis: number;
  thresholdUnit: string;
};

export const LesserChart: React.FC<LesserChartProps> = ({ value, hysteresis, thresholdUnit }) => {
  const { t } = useTranslation('channel-details');
  const { t: tc } = useTranslation('common');
  const leftValue = value;
  const rightValue = value + hysteresis;

  const data = [
    { name: leftValue - 15, value1: 1, value2: 1, value4: 1 },
    { name: leftValue - 15, value1: 1, value2: 1, value4: 1 },
    { name: leftValue - 5, value1: 1, value2: 1, value4: 1 },
    { name: leftValue, value1: 0, value2: 1, value4: 1 },
    { name: rightValue, value1: 0, value2: 0, value3: 1 },
    { name: rightValue + 5, value1: 0, value2: 0, value3: 1 },
    { name: rightValue + 10, value1: 0, value2: 0, value3: 1 },
    { name: rightValue + 15, value1: 0, value2: 0, value3: 1 },
  ];

  return (
    <>
      <Header title={t('meterConfiguration.thresholdEvent.hysteresis')} />
      <ResponsiveContainer width="100%" height={200}>
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" unit={thresholdUnit} />
          <Line type="stepAfter" dataKey="value1" stroke="var(--color-type-primary)" strokeWidth={2} dot={false} />
          <Line type="stepAfter" dataKey="value2" stroke="var(--color-type-primary)" strokeWidth={2} dot={false} />
          <Area type="monotone" dataKey="value3" stroke="var(--color-type-primary)" fill="var(--color-red)" />
          <Area type="monotone" dataKey="value4" stroke="var(--color-type-primary)" fill="var(--color-green)" />
          <ReferenceDot x={3} y={0.35} r={10} fill="var(--color-green)" shape={(props) => <Triangle {...props} />} />
          <ReferenceDot
            x={4}
            y={0.65}
            r={10}
            fill="var(--color-red)"
            shape={(props) => <Triangle {...props} upsideDown={true} />}
          />
          <ReferenceLine y={0} stroke="var(--color-type-primary)" strokeWidth={1.5} />
        </ComposedChart>
      </ResponsiveContainer>
      <ChartLegend
        items={[
          { label: tc('status.off'), color: 'var(--color-red)' },
          { label: tc('status.on'), color: 'var(--color-green)' },
        ]}
      />
    </>
  );
};
